import BaseStrategy from './BaseStrategy';

const Reauthenticate = () => <BaseStrategy authStep="reauthenticate" />;

export default Reauthenticate;
